import cleanfixLogo from "../../../assets/Cleanfix_Logo_rot_RGB.png";

export const Footer = () => {
  return (
    <div className="col-12 text-center footer pt-3">
      <div className="company-info mt-3">
        <img src={cleanfixLogo} className="logo-brand mb-3" alt="Cleanfix" />
        <p className="mb-0 mt-3">Version: {import.meta.env.VITE_UI_VERSION}</p>
      </div>
    </div>
  );
};
